import { isTest } from "@/common/constants/env";

export const LIVE_EDITOR_ANIMATION = {
  transition: isTest ? "none" : "transform 0.5s ease-out",
  sidebarTransition: isTest ? "none" : "transform 0.28s ease-out",
};
